// Harmonogram po remeslách — výpočet hárku úsekov (SPEC harmonogram v1, 2.1; v1.1: zahrnúť, m², trvanie z m², plánované partie).
// Čistý modul bez Reactu.
// Dátumy sú reťazce 'YYYY-MM-DD' a rátajú sa v UTC aritmetike, takže výsledok nezávisí od časového pásma prehliadača.
// „Dnes“ sa sem vždy podáva zvonka (todayLocal z theme.js).

import { jeVolno } from './sviatky.js'   // dni pracovného pokoja podľa zákona (bod 8, 16. 9. 2026)

export const REMESLA = [
  { key: 'omietky', label: 'Omietky' },
  { key: 'malby', label: 'Maľby' },
  { key: 'potery', label: 'Potery' },
]
export const ZAHRNUT = [
  { value: 'byty', label: 'Byty', klaves: 'B' },
  { value: 'spolocne', label: 'Spoločné', klaves: 'S' },
]
export const ZAHRNUT_CELE = ['byty', 'spolocne']
export const PLANOVANA = 'Plánovaná partia'
// predvolený názov plánovanej partie z hárkov v1 — ostáva platný
export const NEOBSADENA = 'Neobsadená partia'
export const POMOCNA = 'Pomocná'
// Horná hranica dní úseku: preklep (99999) by vytvoril Gantt so státisícmi prvkov a zamrzol prehliadač
export const DNI_MAX = 730
export const VYKON_MAX = 100000

const DAY = 86400000
const utc = (iso) => { const p = String(iso).split('-'); return Date.UTC(+p[0], +p[1] - 1, +p[2]) }
const toIso = (ms) => new Date(ms).toISOString().slice(0, 10)
const isIso = (s) => typeof s === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(s)
// pracovný deň = Po–Pi a nie deň pracovného pokoja podľa zákona (Mirko 16. 9. 2026, bod 8 — utils/sviatky.js)
const isWork = (iso) => !jeVolno(iso)
const norm = (v) => String(v == null ? '' : v).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()

export function addCalDays(iso, n) { return toIso(utc(iso) + n * DAY) }
export function diffDays(a, b) { return Math.round((utc(b) - utc(a)) / DAY) }
export function isWeekendIso(iso) { return !isWork(iso) }
export function mondayOf(iso) { const w = new Date(utc(iso)).getUTCDay(); return addCalDays(iso, -((w + 6) % 7)) }

// koniec úseku: kal = začiatok + dni − 1; prac = dni-ty pracovný deň Po–Pi od začiatku (víkendy ani sviatky podľa zákona sa nerátajú)
export function endOf(start, dni, rezim) {
  const n = parseInt(dni, 10)
  if (!isIso(start) || !(n > 0)) return null
  if (rezim !== 'prac') return addCalDays(start, n - 1)
  let d = start, c = 0
  // n pracovných dní sa zmestí do n·7/5 + 2 kalendárnych dní
  for (let guard = 0, max = n * 2 + 14; guard < max; guard++) {
    if (isWork(d)) { c++; if (c === n) return d }
    d = addCalDays(d, 1)
  }
  return d
}

export function nextStart(prevEnd, rezim) {
  let d = addCalDays(prevEnd, 1)
  if (rezim === 'prac') while (!isWork(d)) d = addCalDays(d, 1)
  return d
}

function validDate(y, m, d) {
  const t = Date.UTC(y, m - 1, d), x = new Date(t)
  if (y < 1900 || x.getUTCFullYear() !== y || x.getUTCMonth() !== m - 1 || x.getUTCDate() !== d) return null
  return toIso(t)
}

// 15.09.2026 · 15.9.2026 · 15. 9. 2026 · 1.10.26 · 15.9. · 2026-09-15 · „2026-10-05 00:00:00“ z Excelu; prázdne = '' ; neplatné = null.
// ref = dnešný dátum 'YYYY-MM-DD' (alebo rok): rok mimo ref−5 až ref+10 je preklep (null);
// pri „d.m.“ bez roka sa zvolí rok tak, aby dátum nebol starší ako pol roka pred dneškom.
export function parseDatum(s, ref) {
  let t = String(s == null ? '' : s).trim()
  if (!t) return ''
  t = t.replace(/[ T]\d{1,2}:\d{2}(:\d{2}(\.\d+)?)?$/, '').trim()
  const refIso = isIso(ref) ? ref : ''
  const refRok = refIso ? +refIso.slice(0, 4) : (Number.isInteger(ref) ? ref : null)
  const vRozsahu = (iso) => (!iso || refRok == null ? iso : ((+iso.slice(0, 4) >= refRok - 5 && +iso.slice(0, 4) <= refRok + 10) ? iso : null))
  let m = t.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/)
  if (m) return vRozsahu(validDate(+m[1], +m[2], +m[3]))
  m = t.match(/^(\d{1,2})\s*\.\s*(\d{1,2})\s*\.?\s*(\d{4}|\d{2})?$/)
  if (!m) return null
  if (m[3]) return vRozsahu(validDate(m[3].length === 2 ? 2000 + +m[3] : +m[3], +m[2], +m[1]))
  const rok = refRok != null ? refRok : new Date().getFullYear()
  let iso = validDate(rok, +m[2], +m[1])
  if (iso && refIso && iso < addCalDays(refIso, -183)) iso = validDate(rok + 1, +m[2], +m[1]) || iso
  return iso
}

export function formatDatum(iso) {
  if (!isIso(iso)) return ''
  return iso.slice(8, 10) + '.' + iso.slice(5, 7) + '.' + iso.slice(0, 4)
}
// „16. 9.“ do pruhu Ganttu
export function formatDM(iso) { return isIso(iso) ? (+iso.slice(8, 10)) + '. ' + (+iso.slice(5, 7)) + '.' : '' }

// 131.8: medzera tisícov, desatinná čiarka („1 723,5“)
export function formatCislo(n, des = 0) {
  if (n == null || n === '' || !isFinite(Number(n))) return ''
  const [cele, frac] = Number(n).toFixed(des).split('.')
  const znak = cele.startsWith('-') ? '-' : ''
  return znak + cele.replace('-', '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (frac ? ',' + frac : '')
}
export function formatM2(n) { return formatCislo(n, 1) }

// počet dní: celé číslo 1–DNI_MAX (aj „12,0“ z Excelu); prázdne = '' ; neplatné = null
export function parseDni(s) {
  const t = String(s == null ? '' : s).trim()
  if (!t) return ''
  if (!/^\d+([.,]0+)?$/.test(t)) return null
  const n = parseInt(t, 10)
  return n > 0 && n <= DNI_MAX ? n : null
}

// výkon partie v m² za deň: kladné číslo do VYKON_MAX (aj „180,5“ a „1 200“); prázdne = '' ; neplatné = null
export function parseVykon(s) {
  if (typeof s === 'number') return s > 0 && s <= VYKON_MAX ? Math.round(s * 100) / 100 : null
  const t = String(s == null ? '' : s).replace(/[\s ]/g, '')
  if (!t) return ''
  if (!/^\d+([.,]\d+)?$/.test(t)) return null
  const n = parseFloat(t.replace(',', '.'))
  return n > 0 && n <= VYKON_MAX ? Math.round(n * 100) / 100 : null
}
export function vykonSlotu(slot) {
  const v = slot ? parseVykon(slot.vykon_den) : null
  return typeof v === 'number' ? v : null
}

export function dniText(n) { const a = Math.abs(n); return a === 1 ? 'deň' : (a >= 2 && a <= 4 ? 'dni' : 'dní') }
export function usekyText(n) { return n === 1 ? 'úsek' : (n >= 2 && n <= 4 ? 'úseky' : 'úsekov') }

export function newId(prefix = 'r') { return prefix + Date.now().toString(36) + Math.random().toString(36).slice(2, 6) }

export function nextSlotId(harok) {
  let max = 0
  for (const p of (harok && harok.partie) || []) { const n = parseInt(String(p.slot || '').replace(/^s/, ''), 10); if (n > max) max = n }
  return 's' + (max + 1)
}

// „Pomocná N“ s prvým voľným číslom medzi názvami slotov hárka
export function nazovPomocnej(harok) {
  const pouzite = new Set(((harok && harok.partie) || []).map(p => norm(p.nazov)))
  let n = 1
  while (pouzite.has(norm(POMOCNA + ' ' + n))) n++
  return POMOCNA + ' ' + n
}

export function isPlanovana(slot) { return !!slot && !slot.party_id }

// Názov plánovanej partie na zobrazenie: predvolený názov z v1 („Neobsadená partia“, aj s číslom) sa v UI volá Plánovaná partia.
export function nazovPlanovanej(slot) {
  const n = String((slot && slot.nazov) || '').trim()
  if (!n) return PLANOVANA
  const m = norm(n).match(/^neobsadena\s+partia(\s+\d+)?$/)
  return m ? PLANOVANA + (m[1] ? ' ' + m[1].trim() : '') : n
}

// Zahrnúť riadku: pole z 'byty'/'spolocne'. Riadok v1 bez poľa zahrnut sa odvodí z typ (spoločné aj schodisko = spoločné).
export function zahrnutOf(r) {
  if (r && Array.isArray(r.zahrnut)) {
    const z = ZAHRNUT_CELE.filter(v => r.zahrnut.includes(v))
    if (z.length) return z
  }
  if (r && (r.typ === 'spolocne' || r.typ === 'schodisko')) return ['spolocne']
  return ['byty']
}
export function zahrnutText(z) {
  const a = Array.isArray(z) ? z : []
  if (a.includes('byty') && a.includes('spolocne')) return 'Celé poschodie'
  return a.includes('spolocne') ? 'Spoločné priestory' : 'Byty'
}
// stĺpec Zahrnúť z Excelu: „byty“, „spoločné“, „celé“, „oboje“ (aj B, S, schodisko, chodba); prázdne = celé poschodie
export function parseZahrnut(text) {
  const t = norm(text)
  if (!t) return { zahrnut: ZAHRNUT_CELE.slice(), chyba: false }
  const z = new Set()
  let chyba = false
  for (const tok of t.split(/[\s+,;/&.]+/).filter(Boolean)) {
    if (['a', 'aj', 'i', 'priestory', 'priestor', 'poschodie'].includes(tok)) continue
    if (['byty', 'byt', 'bytov', 'b'].includes(tok)) z.add('byty')
    else if (['spolocne', 'spolocny', 'spolocnych', 'spol', 's', 'schodisko', 'schodiska', 'chodba', 'chodby'].includes(tok)) z.add('spolocne')
    else if (['cele', 'cely', 'oboje', 'obe', 'vsetko', 'vsetky'].includes(tok)) { z.add('byty'); z.add('spolocne') }
    else chyba = true
  }
  const out = ZAHRNUT_CELE.filter(v => z.has(v))
  return chyba || !out.length ? { zahrnut: ZAHRNUT_CELE.slice(), chyba: true } : { zahrnut: out, chyba: false }
}

export function newRiadok(patch) {
  return { id: newId('r'), slot: '', usek: '', zahrnut: ZAHRNUT_CELE.slice(), objekty: [], zaciatok: '', trvanie: 'dni', dni: '', hotovo: false, pozn: '', ...(patch || {}) }
}

export function emptyHarok() {
  return { v: 1, termin: '', dni: 'kal', partie: [], riadky: [newRiadok()] }
}

// prázdny pripravený riadok (bez partie, úseku, začiatku aj dní) sa nepočíta do KPI ani stavu
export function isEmptyRiadok(r) { return !r || (!r.slot && !String(r.usek || '').trim() && !r.zaciatok && !r.dni) }

// zjednotí tvar načítaného hárku (v1 → v1.1 len v pamäti; typ sa pri ďalšom uložení už nezapíše); neznáme kľúče ostanú zachované
export function normalizeHarok(h) {
  if (!h || typeof h !== 'object' || Array.isArray(h)) return emptyHarok()
  const riadky = Array.isArray(h.riadky) ? h.riadky.filter(r => r && typeof r === 'object').map(r => {
    const { typ: _typ, ...rest } = r
    return {
      ...rest,
      id: r.id ? String(r.id) : newId('r'),
      slot: r.slot ? String(r.slot) : '',
      usek: r.usek == null ? '' : String(r.usek),
      zahrnut: zahrnutOf(r),
      objekty: Array.isArray(r.objekty) ? r.objekty.map(String) : [],
      zaciatok: isIso(r.zaciatok) ? r.zaciatok : '',
      trvanie: r.trvanie === 'm2' ? 'm2' : 'dni',
      dni: parseInt(r.dni, 10) > 0 ? parseInt(r.dni, 10) : '',
      hotovo: !!r.hotovo,
    }
  }) : []
  return {
    ...h,
    v: 1,
    termin: isIso(h.termin) ? h.termin : '',
    dni: h.dni === 'prac' ? 'prac' : 'kal',
    partie: Array.isArray(h.partie) ? h.partie.filter(p => p && p.slot).map(p => ({ ...p, vykon_den: vykonSlotu(p) })) : [],
    riadky: riadky.length ? riadky : [newRiadok()],
  }
}

export function slotOf(harok, slotId) { return ((harok && harok.partie) || []).find(p => p.slot === slotId) || null }

// „8. NP“, „8.NP“, „8“ → '8NP'; „1. PP“ → '1PP'
export function poKey(s) {
  const m = String(s == null ? '' : s).toUpperCase().match(/(\d+)\s*\.?\s*(NP|PP)?/)
  return m ? m[1] + (m[2] || 'NP') : null
}
export function poLabel(s) { const k = poKey(s); return k ? k.replace(/^(\d+)(NP|PP)$/, '$1. $2') : String(s || '') }

// úsek s viacerými číslami („2. NP – 3. NP“, „Schodisko 1.–8. NP“, „Byt 12, 3. NP“) sa nedá priradiť jednému poschodiu Výmer
export function viacPoschodi(usek) { return (String(usek == null ? '' : usek).match(/\d+/g) || []).length > 1 }

// poschodia štruktúry Výmer pre úsek: objekty riadku × poschodie s rovnakým číslom
function poschodiaUseku(riadok, struktura) {
  const key = poKey(riadok && riadok.usek)
  const obj = riadok && Array.isArray(riadok.objekty) ? riadok.objekty.map(String) : []
  if (!key || viacPoschodi(riadok.usek) || !obj.length || !struktura || !Array.isArray(struktura.poschodia)) return []
  return struktura.poschodia.filter(p => obj.includes(String(p.obj)) && poKey(p.po) === key)
}

// objekty úseku, ktoré dané poschodie vo Výmerách nemajú — m² a byty úseku sú vtedy len z ostatných objektov
export function objektyBezPoschodia(riadok, struktura) {
  const key = poKey(riadok && riadok.usek)
  const obj = riadok && Array.isArray(riadok.objekty) ? riadok.objekty.map(String) : []
  if (!key || viacPoschodi(riadok.usek) || !obj.length || !struktura || !Array.isArray(struktura.poschodia) || !struktura.poschodia.length) return []
  return obj.filter(o => !struktura.poschodia.some(p => String(p.obj) === o && poKey(p.po) === key))
}

// počet bytov úseku; len ak Zahrnúť obsahuje byty
export function bytyUseku(riadok, struktura) {
  if (!riadok || !zahrnutOf(riadok).includes('byty')) return null
  const ps = poschodiaUseku(riadok, struktura)
  return ps.length ? ps.reduce((s, p) => s + (Number(p.byty) || 0), 0) : null
}

// počet spoločných priestorov úseku; len ak Zahrnúť obsahuje spoločné (starý server pole nevracia → null)
export function spolocneUseku(riadok, struktura) {
  if (!riadok || !zahrnutOf(riadok).includes('spolocne')) return null
  const ps = poschodiaUseku(riadok, struktura)
  if (!ps.length || ps.some(p => p.spolocne == null)) return null
  return ps.reduce((s, p) => s + (Number(p.spolocne) || 0), 0)
}

// m² úseku = m2_byty a/alebo m2_spolocne podľa Zahrnúť; štruktúra bez týchto polí (starý server) → null
export function m2Useku(riadok, struktura) {
  const ps = poschodiaUseku(riadok, struktura)
  if (!ps.length) return null
  const z = zahrnutOf(riadok)
  let sum = 0
  for (const p of ps) {
    for (const [v, pole] of [['byty', 'm2_byty'], ['spolocne', 'm2_spolocne']]) {
      if (!z.includes(v)) continue
      if (p[pole] == null || !isFinite(Number(p[pole]))) return null
      sum += Number(p[pole])
    }
  }
  return Math.round(sum * 100) / 100
}

// Prázdny začiatok = pokračuje po konci predchádzajúceho riadku TOHO ISTÉHO slotu (v poradí tabuľky).
// Riadok so začiatkom bez konca (chýbajú dni, výkon alebo m², neplatná bunka) reťaz preruší — ďalší automatický úsek by sa inak
// potichu naviazal na starší riadok a prekryl sa s ním.
// Trvanie 'm2' = ceil(m² úseku / výkon slotu za deň), najmenej 1; bez štruktúry sa z m² počítať nedá.
// opts.neplatne = Set id riadkov s neplatnou rozpísanou bunkou.
export function computeRows(harok, today, struktura, opts) {
  const rezim = harok && harok.dni === 'prac' ? 'prac' : 'kal'
  const termin = harok && isIso(harok.termin) ? harok.termin : ''
  const neplatne = opts && opts.neplatne ? opts.neplatne : null
  const riadky = (harok && harok.riadky) || []
  const last = {}, prerusene = {}
  const rows = riadky.map(r => {
    if (isEmptyRiadok(r)) return { start: null, auto: false, end: null, dni: 0, dni_efekt: 0, m2: null, vykon_odhad: null, stav: { kod: '', text: '' }, prazdny: true }
    const zlom = !!(r.slot && prerusene[r.slot])
    let start = isIso(r.zaciatok) ? r.zaciatok : null, auto = false
    if (!start && r.slot && last[r.slot]) { start = nextStart(last[r.slot], rezim); auto = true }
    const m2 = m2Useku(r, struktura)
    const zM2 = r.trvanie === 'm2'
    let dni = 0, chyba = null, stavTrvania = null
    if (zM2) {
      const slot = slotOf(harok, r.slot)
      const vykon = vykonSlotu(slot)
      const bezPoschodia = objektyBezPoschodia(r, struktura)
      if (!slot) { chyba = 'partia'; stavTrvania = { kod: 'zasah', text: 'Chýba partia', popis: 'Trvanie z m² sa počíta z výkonu partie — vyber partiu' } }
      else if (!(m2 > 0) || bezPoschodia.length) {
        chyba = 'm2'
        const popis = viacPoschodi(r.usek) ? 'Úsek zasahuje viac poschodí — rozdeľ ho na poschodia alebo zadaj trvanie v dňoch'
          : bezPoschodia.length ? `${formatObjekty(bezPoschodia)} ${bezPoschodia.length === 1 ? 'nemá' : 'nemajú'} ${poLabel(r.usek)} vo Výmerách — uprav objekty úseku alebo zadaj trvanie v dňoch`
            : 'Úsek nemá m² vo Výmerách — skontroluj úsek, objekty a Zahrnúť alebo zadaj trvanie v dňoch'
        stavTrvania = { kod: 'zasah', text: 'Chýbajú m²', popis }
      }
      else if (!vykon) { chyba = 'vykon'; stavTrvania = { kod: 'zasah', text: 'Chýba výkon partie', popis: 'Doplň výkon partie (m² za deň) v okne Partie a výkon' } }
      else {
        // zaokrúhlenie pred ceil: 1723,5 / 172,35 v pohyblivej čiarke nie je presne 10
        const n = Math.max(1, Math.ceil(Math.round(m2 / vykon * 1e6) / 1e6))
        if (n > DNI_MAX) { chyba = 'vykon'; stavTrvania = { kod: 'zasah', text: 'Príliš malý výkon', popis: `Z m² vychádza viac ako ${DNI_MAX} dní — skontroluj výkon partie` } }
        else dni = n
      }
    } else {
      dni = parseInt(r.dni, 10) > 0 ? parseInt(r.dni, 10) : 0
    }
    const neplatny = !!(neplatne && neplatne.has(r.id))
    const end = start && dni > 0 && !neplatny ? endOf(start, dni, rezim) : null
    if (r.slot) {
      if (end) { last[r.slot] = end; prerusene[r.slot] = false }
      else if (start || neplatny) { last[r.slot] = null; prerusene[r.slot] = true }
    }
    let stav
    const predosly = !neplatny && !start && zlom
    if (neplatny) stav = { kod: 'chyba', text: 'Neplatný údaj', popis: 'Bunka v riadku má neplatnú hodnotu a neuloží sa' }
    else if (predosly) stav = { kod: 'zasah', text: 'Predošlý bez konca', popis: 'Predchádzajúci úsek partie nemá koniec — doplň mu trvanie alebo zadaj začiatok' }
    else if (!start) stav = { kod: 'zasah', text: 'Chýba začiatok' }
    // úsek označený ako hotový je hotový aj bez konca (napríklad trvanie z m² bez výkonu)
    else if (r.hotovo) stav = { kod: 'hotovo', text: 'Hotovo' }
    else if (!end) stav = stavTrvania || { kod: 'zasah', text: 'Chýbajú dni' }
    else if (termin && end > termin) stav = { kod: 'chyba', text: 'Po termíne' }
    else if (end < today) stav = { kod: 'hotovo', text: 'Hotovo' }
    else if (start <= today) stav = { kod: 'prebieha', text: 'Prebieha' }
    else stav = { kod: 'neutralne', text: 'Plánované' }
    return {
      start, auto, end, dni, dni_efekt: dni, m2,
      vykon_odhad: !zM2 && m2 > 0 && dni > 0 ? Math.round(m2 / dni) : null,
      chyba, stav, neplatny, predosly,
    }
  })
  // tá istá partia na dvoch úsekoch v rovnakých dňoch (aj po zlúčení slotov alebo pri ručných začiatkoch)
  const kluc = (r) => { const s = slotOf(harok, r.slot); return s && s.party_id ? 'p:' + s.party_id : (r.slot ? 's:' + r.slot : '') }
  rows.forEach((c, i) => {
    if (!c.end || (c.stav.kod !== 'prebieha' && c.stav.kod !== 'neutralne')) return
    const k = kluc(riadky[i])
    if (!k) return
    const j = rows.findIndex((d, jj) => jj !== i && d.end && !riadky[jj].hotovo && kluc(riadky[jj]) === k && c.start <= d.end && d.start <= c.end)
    if (j >= 0) {
      const u = riadky[j].usek ? String(riadky[j].usek) : 'riadok ' + (j + 1)
      c.stav = { kod: 'zasah', text: 'Prekrýva sa', popis: 'Partia má v rovnakých dňoch aj úsek ' + u }
    }
  })
  return rows
}

export function isNeobsadena(harok, riadok) {
  const s = riadok && riadok.slot ? slotOf(harok, riadok.slot) : null
  return !s || !s.party_id
}

// Treba zásah = nehotový úsek bez partie alebo so stavom zásahu (chýba začiatok, dni, výkon, m², prekrytie) alebo s neplatnou bunkou.
// Plánovaná partia nie je zásah, počíta sa zvlášť (planovane_useky).
// Každý úsek so zásahom je v práve jednej časti (bez partie, čaká na predošlý, bez začiatku, bez výkonu, bez m², iné), súčet častí = treba_zasah.
export function computeKpi(harok, rows, today) {
  const riadky = (harok && harok.riadky) || []
  const termin = harok && isIso(harok.termin) ? harok.termin : ''
  let koniec = null, posledny = null, pocet = 0, hotove = 0, prebieha = 0, neobsadene = 0, planovane = 0, bezPartie = 0
  let bezZaciatku = 0, cakaNaPredosly = 0, bezVykonu = 0, bezM2 = 0, ine = 0, zasah = 0, neuplny = false, m2Spolu = 0
  rows.forEach((c, i) => {
    if (!c || c.prazdny) return
    pocet++
    if (c.m2 > 0) m2Spolu += c.m2
    if (c.end && (!koniec || c.end > koniec)) { koniec = c.end; posledny = riadky[i] ? riadky[i].usek : '' }
    if (!c.end) neuplny = true
    const hot = c.stav.kod === 'hotovo'
    if (hot) hotove++
    else if (c.stav.kod === 'prebieha') prebieha++
    if (hot) return
    const slot = riadky[i] && riadky[i].slot ? slotOf(harok, riadky[i].slot) : null
    const problem = c.stav.kod === 'zasah' || !!c.neplatny
    if (!slot || !slot.party_id) neobsadene++
    if (slot && !slot.party_id) planovane++
    if (!slot || problem) {
      zasah++
      if (!slot) bezPartie++
      else if (!c.start) { if (c.predosly) cakaNaPredosly++; else bezZaciatku++ }
      else if (c.chyba === 'vykon') bezVykonu++
      else if (c.chyba === 'm2') bezM2++
      else ine++
    }
  })
  return {
    koniec,
    posledny_usek: posledny,
    rezerva_dni: koniec && termin ? diffDays(koniec, termin) : null,
    hotove, prebieha,
    ostatne: pocet - hotove - prebieha,
    pocet,
    neobsadene_useky: neobsadene,
    planovane_useky: planovane,
    bez_partie: bezPartie,
    bez_zaciatku: bezZaciatku,
    caka_na_predosly: cakaNaPredosly,
    bez_vykonu: bezVykonu,
    bez_m2: bezM2,
    ine_problemy: ine,
    treba_zasah: zasah,
    neuplny,
    m2_spolu: Math.round(m2Spolu * 100) / 100,
  }
}

export function formatObjekty(arr) { return (Array.isArray(arr) ? arr : []).join(' + ') }

// „A + B“, „A,B“, „všetky“ → ['A','B']; neznámy objekt = chyba (ak štruktúra objekty pozná)
export function parseObjekty(text, objekty) {
  const all = Array.isArray(objekty) ? objekty.map(String) : []
  const t = String(text == null ? '' : text).trim()
  if (!t) return { objekty: [], chyba: false }
  if (['vsetky', 'vsetko', '*'].includes(norm(t))) return { objekty: all.slice(), chyba: !all.length }
  const tokens = t.split(/[\s+,;/&]+/).map(x => x.trim()).filter(Boolean)
  const out = []
  let chyba = false
  for (const tok of tokens) {
    const hit = all.find(o => norm(o) === norm(tok))
    if (hit) { if (!out.includes(hit)) out.push(hit) }
    else if (!all.length) { const u = tok.toUpperCase(); if (!out.includes(u)) out.push(u) }
    else chyba = true
  }
  if (all.length) out.sort((a, b) => all.indexOf(a) - all.indexOf(b))
  return { objekty: out, chyba: chyba || !out.length }
}

// Text na farebnom pruhu: z tmavého a svetlého textu ten s vyšším kontrastom (WCAG) voči farbe partie.
function jas(hex) {
  let h = String(hex || '').trim().replace(/^#/, '')
  if (h.length === 3) h = h.split('').map(c => c + c).join('')
  if (!/^[0-9a-f]{6}$/i.test(h)) return null
  const ch = (i) => { const v = parseInt(h.slice(i, i + 2), 16) / 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4) }
  return 0.2126 * ch(0) + 0.7152 * ch(2) + 0.0722 * ch(4)
}
export function kontrast(a, b) {
  const x = jas(a), y = jas(b)
  if (x == null || y == null) return null
  return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05)
}
export function textNaFarbe(hex, tmavy, svetly) {
  const kt = kontrast(hex, tmavy), ks = kontrast(hex, svetly)
  if (kt == null || ks == null) return tmavy
  return kt >= ks ? tmavy : svetly
}

// Vloženie z Excelu: stĺpce Partia, Úsek, Objekty, Začiatok, Dni, voliteľne Zahrnúť.
// partieList = [{key, party_id, nazov, partak_meno}] — skutočné partie aj plánované sloty hárka (party_id null).
// ref = dnešný dátum (pozri parseDatum). Voľná zhoda na viac partií sa nevyberie (nejednoznacna = počet kandidátov).
// Nespárované meno sa vloží ako plánovaná partia s vloženým menom (planovana, planovana_nazov);
// prázdna alebo nejednoznačná partia ostane bez partie, aby ju ukázal Treba zásah.
export function parseTsv(text, partieList, struktura, ref) {
  const lines = String(text == null ? '' : text).replace(/\r/g, '').split('\n').filter(l => l.trim())
  const list = Array.isArray(partieList) ? partieList : []
  const objekty = struktura && Array.isArray(struktura.objekty) ? struktura.objekty : []
  const out = []
  lines.forEach((line, i) => {
    const c = line.split('\t')
    if (i === 0 && norm(c[0]) === 'partia') return
    const partiaText = String(c[0] || '').trim()
    const q = norm(partiaText)
    let partia = null, nejednoznacna = 0
    if (q) {
      partia = list.find(p => norm(p.party_id) === q || norm(p.nazov) === q || (p.partak_meno && norm(p.partak_meno) === q)) || null
      if (!partia) {
        // plánovaná partia (party_id null) len presnou zhodou: „Pomocná partia 2“ nie je „Pomocná partia“, „Pomocná 10“ nie je „Pomocná 1“
        const kand = list.filter(p => p.party_id && ((p.nazov && norm(p.nazov).includes(q) && q.length > 2) || (p.partak_meno && q.includes(norm(p.partak_meno))) || (p.nazov && q.includes(norm(p.nazov)))))
        if (kand.length === 1) partia = kand[0]
        else if (kand.length > 1) nejednoznacna = kand.length
      }
    }
    const zacText = String(c[3] || '').trim()
    const zac = parseDatum(zacText, ref)
    const dniTextRaw = String(c[4] || '').trim()
    const dni = parseDni(dniTextRaw)
    const objText = String(c[2] || '').trim()
    const ob = objText ? parseObjekty(objText, objekty) : { objekty: objekty.slice(), chyba: false }
    const zahText = String(c[5] || '').trim()
    const za = parseZahrnut(zahText)
    out.push({
      partia_text: partiaText,
      partia,
      sparovana: !!partia,
      // spárovaná voľnou zhodou (zapísané meno sa líši od názvu, kódu aj parťáka) — náhľad to ukáže
      ina_zhoda: !!partia && ![partia.nazov, partia.party_id, partia.partak_meno].some(v => v && norm(v) === q),
      nejednoznacna,
      planovana: partia ? !partia.party_id : (!!q && !nejednoznacna),
      planovana_nazov: partia ? (partia.party_id ? '' : partia.nazov || '') : (q && !nejednoznacna ? partiaText.replace(/\s+/g, ' ') : ''),
      usek: String(c[1] || '').trim(),
      objekty: ob.objekty,
      objekty_text: objText,
      objekty_chyba: ob.chyba,
      zaciatok: zac || '',
      zaciatok_text: zacText,
      zaciatok_chyba: zac === null,
      dni: dni || '',
      dni_text: dniTextRaw,
      dni_chyba: dni === null,
      zahrnut: za.zahrnut,
      zahrnut_text: zahText,
      zahrnut_chyba: za.chyba,
    })
  })
  return out
}
